import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

// import config from '../Config'
import { SocketTypes, ChatTypes } from '../../actions'

export const INITIAL_STATE = Immutable({
  activeAgentName: '',
  agentIsTyping: false,
  authenticationKey: '',
  chatEndInfo: {},
  chatId: null,
  estimatedWaitTime: null,
  numberOfParticipants: 0,
  previousStage: '',
  stage: '',
  waitMessage: '',
})

const newChatResponse = (state, { result }) =>
  state.merge({
    authenticationKey: result.authenticationKey,
    chatId: result.chatId,
  })

const newStage = (state, { result }) => state.merge({ stage: result.stage })

const endStage = (state, { result }) => state.merge({ previousStage: result.stage })

const newParticipant = (state, { result }) =>
  state.merge({
    numberOfParticipants: state.numberOfParticipants + 1,
    activeAgentName: result.participant.type === 'AGENT' ? result.participant.displayName : state.activeAgentName,
  })

const participantLeave = (state) =>
  state.merge({
    numberOfParticipants: state.numberOfParticipants - 1,
  })

const wait = (state, { result }) =>
  state.merge({ estimatedWaitTime: result.time || INITIAL_STATE.estimatedWaitTime, waitMessage: result.message })

const agentIsTyping = (state, { result }) => state.merge({ agentIsTyping: result })

const endChat = (state, { result }) =>
  state.merge({
    chatEndInfo: {
      alternateChannels: result.alternateChannels,
      ended: true,
      reason: result.reason,
      status: result.status,
    },
  })

const resetParticipants = (state) =>
  state.merge({
    numberOfParticipants: 0,
  })

const resetChatInfo = (state) => state.merge({ ...INITIAL_STATE })

const ACTION_HANDLERS = {
  [SocketTypes.NEW_CHAT_RESPONSE]: newChatResponse,
  [SocketTypes.NEW_STAGE]: newStage,
  [SocketTypes.END_STAGE]: endStage,

  [SocketTypes.WAIT]: wait,

  [SocketTypes.NEW_PARTICIPANT]: newParticipant,
  [SocketTypes.PARTICIPANT_LEAVE]: participantLeave,

  [SocketTypes.IS_TYPING]: agentIsTyping,
  [SocketTypes.END_CHAT]: endChat,

  [ChatTypes.RESET_PARTICIPANTS]: resetParticipants,
  [ChatTypes.RESET_CHAT_INFO]: resetChatInfo,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
